// extracted by mini-css-extract-plugin
module.exports = {"Reward":"ChooseRewardScreen_Reward__3BS49","Title":"ChooseRewardScreen_Title__zvm6y"};